/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Upload_Error_DefaultInputs */

const en_mobile_upload_error_default = /** @type {(inputs: Mobile_Upload_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't upload this item. Please try again.`)
};

const es_mobile_upload_error_default = /** @type {(inputs: Mobile_Upload_Error_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos subir este elemento. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "We couldn't upload this item. Please try again." |
*
* @param {Mobile_Upload_Error_DefaultInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_upload_error_default = /** @type {((inputs?: Mobile_Upload_Error_DefaultInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Upload_Error_DefaultInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_upload_error_default(inputs)
	return en_mobile_upload_error_default(inputs)
});